import { Component, OnInit } from '@angular/core';
import {SessionService} from '../../../core/services/sessionService';
import {Router} from '@angular/router';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {
  class;
data: any
  constructor(private sessionService: SessionService, private route: Router) { }

  ngOnInit() {
  this.class = '';
      this.data = this.sessionService.getSession()
  }

    toggleDropDown(item){
        if(this.class === ''){
            this.class = 'display:block';
        } else{
            this.class = '';
        }
        item.style = this.class;
    }

    logout(){
        this.sessionService.endSession();
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/user/user.component.ts